




































































































































import {Vue, Component} from 'vue-property-decorator';
import {addClass, removeClass} from '@/utils/classUtils';
import { GetOrderProducts, GetOrderProductsOrderOption, GetOrderProductsRequest } from 'supporter';
import {i18nObjectByKey} from '@/utils/i18n';
import { getCurrency } from '@/utils/commonUtils';
import {
  LayerType,
  OrderFreeGiftConditionNo,
  OrderLayerPopupData,
  OrderLayerPopupFundamentalData,
  OrderProduct,
} from '@/types/order';
import {
  curriedLayerDataCreator,
  curriedProductCouponLayer,
} from '@/views/order/popup/OrderLayer';
import { LAYER_TYPE } from '@/const/words/orderLayer';
import {uniq} from 'underscore';
@Component
export default class OrderDiscount extends Vue {
  private readonly getCurrency = getCurrency;
  private readonly LAYER_TYPE = LAYER_TYPE;
  private orderInfo: any = {};
  private productInfo: OrderProduct[] = [];
  private couponInfo: any[] = [];
  private couponNum: any = null;
  private discountNo: any = null;
  private cartDiscountNum: any = null;
  private showCouponNo: boolean = false;
  private showDiscountNo: boolean = false;
  private showCartDiscount: boolean = false;
  private showFreeGiftConditionNo = false;
  
  private couponNoData: OrderLayerPopupFundamentalData = curriedProductCouponLayer('ORDER_ORDER_DETAIL_PRODUCT_COUPON_TITLE');
  private discountNoData: OrderLayerPopupFundamentalData = curriedProductCouponLayer('ORDER_ORDER_DETAIL_DISCOUNT_TITLE');
  private cartDiscountData: OrderLayerPopupFundamentalData = curriedProductCouponLayer('ORDER_ORDER_DETAIL_CART_DISCOUNT_TITLE');
  private freeGiftConditionNoData: OrderLayerPopupData<OrderFreeGiftConditionNo> = {
    ...curriedLayerDataCreator('freeGiftConditionNoLayer')('ORDER_ORDER_DETAIL_FREE_GIFT_TITLE'),
    data: {
      conditionNos: [],
    }
  };
  
  private isLast: boolean = false;

  private created(): void {
    this.couponNoData = i18nObjectByKey(this, this.couponNoData, 'title');
    this.discountNoData = i18nObjectByKey(this, this.discountNoData, 'title');
    this.cartDiscountData = i18nObjectByKey(this, this.cartDiscountData, 'title');
    this.checkFirstOrLast();
  }
  private mounted(): void {
    addClass(document.body, 'popup popup_small');
    this.getOrderProductInfo();
    this.getOrderInfo();
    this.getCouponInfo();
  }
  private beforeDestroy(): void {
    removeClass(document.body, 'popup popup_small');
  }

  private handleWindowClose(): void {
    window.close();
  }
  private checkAddtionalDiscount(isLast: boolean, last: any, first: any): any {
    if (isLast && last) {
      return true;
    } else if (!isLast && first) {
      return true;
    } else {
      return false;
    }
  }
  private checkFirstOrLast(): void {
    if (this.$route.path === '/order/last-discount') {
      this.isLast = true;
    } else {
      this.isLast = false;
    }
  }
  
  private handleLayerDetail(layerName: LayerType, data) {
    this.layerTrigger[layerName] && this.layerTrigger[layerName](data);
  }
  
  private layerTrigger = {
    [LAYER_TYPE.COUPON]: (couponNum) => window.open(`/promotion/coupon/modifyForm?couponNo=${couponNum}`),
    [LAYER_TYPE.DISCOUNT]: (discountNo) => window.open(`/promotion/additional-discount/management/modification?no=${discountNo}`),
    [LAYER_TYPE.CART_DISCOUNT]: (cartDiscountNum) => window.open(`/promotion/coupon/modifyForm?couponNo=${cartDiscountNum}`),
    [LAYER_TYPE.FREE_GIFT_CONDITION]: (conditionNo) => {
      window.open(`/promotion/free-gift/condition/edit/${conditionNo}`);
      window.close();
    },
  }
  
  private getCouponInfo(): void {
    let couponRequest: any = {
      params: {
        orderNo: this.$route.query.orderNo as any
      }
    };
    this.$api.getCouponsUse(couponRequest).then((res: any): any => {
      this.couponInfo = [];
      this.couponInfo = res.data;
    });
  }
  
  private showLayer(layerName: LayerType, data: any): void {
    this.showLayerTrigger[layerName] && this.showLayerTrigger[layerName].call(this, data);
  }
  
  private showLayerTrigger = {
    [LAYER_TYPE.COUPON](data) {
      this.popUpCoupon(data);
    },
    [LAYER_TYPE.DISCOUNT](data) {
      this.popUpDiscount(data);
    },
    [LAYER_TYPE.CART_DISCOUNT]() {
      this.popUpCartDiscount();
    },
    [LAYER_TYPE.FREE_GIFT_CONDITION](data) {
      this.popUpFreeGiftCondition(data);
    }
  }
  
  private popUpCoupon(data) {
    if (this.couponInfo.length === 0) {
      return;
    }
    this.couponInfo.forEach((item: any): any => {
      if (item.orderProductNo === data.orderProductNo && item.couponType === 'PRODUCT') {
        this.couponNum = item.couponNo;
      }
    });
    this.showCouponNo = true;
  }
  
  private popUpDiscount(data) {
    if (!data.orderOptions) return;
    this.discountNo = data.orderOptions[0]['additionalDiscountNo'];
    this.showDiscountNo = true;
  }
  
  private popUpCartDiscount() {
    if (this.couponInfo.length === 0) {
      return;
    }
  
    this.couponInfo.forEach((item: any): any => {
      if (item.couponType === 'CART') {
        this.cartDiscountNum = item.couponNo;
        return;
      }
    });
    this.showCartDiscount = true;
  }
  
  private popUpFreeGiftCondition(data) {
    const conditionNos = data?.freeGiftConditionNos;
    if (!conditionNos.length) {
      // @TODO 테스트 데이터 때문에 지급번호가 없는 경우가 존재하여 방어코드 삽입. 이후 데이터 정리가 되면 해당 부분 삭제예정 bomee.yoon
      alert('테스트 데이터로 등록된 지급번호가 없습니다. 확인 요망');
      return;
    }
    this.$set(this.freeGiftConditionNoData.data, 'conditionNos', conditionNos);
    this.showFreeGiftConditionNo = true;
  }

  private getOrderProductInfo(): void {
    let ProductInfoRequest: GetOrderProductsRequest = {
      params: {
        orderNo: this.$route.query.orderNo as any
      }
    };
    this.$api.getOrderProducts(ProductInfoRequest).then(({ data }) => {
      const predicate = (orderOption: GetOrderProductsOrderOption, product: GetOrderProducts): boolean => orderOption.orderProductNo === product.orderProductNo && orderOption.orderNo === product.orderNo;
      
			this.productInfo = data.map((item) => {
        const { isFreeGift, freeGiftConditionBrokenType } = item.orderOptions.find((orderOption) => predicate(orderOption, item));
				const freeGifts = item.orderOptions.filter(({ isFreeGift }) => isFreeGift)
        const freeGiftConditionNos = uniq(freeGifts.map(({ freeGiftConditionNo }) => freeGiftConditionNo));
				const freeGiftDiscountAmt = freeGifts.map(({ freeGiftDiscountAmt }) => freeGiftDiscountAmt);
				return {
          ...item,
          freeGiftConditionBrokenType,
          freeGiftDiscountAmt: freeGiftDiscountAmt.reduce((a, b) => a + b, 0),
          isFreeGift,
					freeGiftConditionNos
        }
      });
    });
  }

  private getOrderInfo(): void {
    let orderRequest: any = {
      params: {
        orderNo: this.$route.query.orderNo as any
      }
    };
    this.$api.getOrdersByOrderNo(orderRequest).then((res: any): any => {
      let order: any = res.data;
      this.orderInfo = {
        cartCouponFirst: order.firstBalance.cartCouponDiscountAmt,
        cartCouponLast: order.lastBalance.cartCouponDiscountAmt
      };
    });
  }
}
